import { useEffect } from 'react';
import { usePageContext } from 'vike-react/usePageContext';
import * as Sentry from '@sentry/react';

/**
 * Hook to automatically set Sentry user context based on session
 */
export function useSentryUser() {
  const pageContext = usePageContext();
  const user = (pageContext as any)?.user;

  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.name || user.email,
      });
      
      // Also set GA4 user properties
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('set', 'user_properties', {
          user_id: user.id,
          user_type: 'authenticated',
        });
      }
    } else {
      // Anonymous user
      Sentry.setUser({
        id: undefined,
        username: 'anonymous',
      });
    }
  }, [user?.id]); // Only re-run when user ID changes
}

